import { Routes, Route, Navigate } from 'react-router-dom'
import { ProtectedRoute } from '@/components/shared/ProtectedRoute'
import { Layout } from '@/components/shared/Layout'
import Login from '@/pages/Login'
import Queue from '@/pages/Queue'
import OrderReview from '@/pages/OrderReview'
import ActiveDropships from '@/pages/ActiveDropships'
import DropshipDetail from '@/pages/DropshipDetail'
import Reports from '@/pages/Reports'
import Visibility from '@/pages/Visibility'
import Settings from '@/pages/Settings'
import Health from '@/pages/Health'
import Audit from '@/pages/Audit'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/queue" replace />} />
        <Route path="/queue" element={<Queue />} />
        <Route path="/queue/:shopifyOrderId" element={<OrderReview />} />
        <Route path="/active" element={<ActiveDropships />} />
        <Route path="/active/:dropshipOrderId" element={<DropshipDetail />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/visibility" element={<Visibility />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/health" element={<Health />} />
        <Route path="/audit" element={<Audit />} />
      </Route>
      <Route path="*" element={<Navigate to="/queue" replace />} />
    </Routes>
  )
}
